import { render, staticRenderFns } from "./CommandsDetail.vue?vue&type=template&id=2859c9be"
import script from "./CommandsDetail.vue?vue&type=script&lang=js"
export * from "./CommandsDetail.vue?vue&type=script&lang=js"
import style0 from "./CommandsDetail.vue?vue&type=style&index=0&id=2859c9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports